import React from "react";
import type { ThoughtBlock } from "../data/thoughts";
import { BODY, EYEBROW, H2, H3 } from "../utils/typography";
type ThoughtBodyProps = {
  blocks: ThoughtBlock[];
};

// Two treatments only: reading text (plain or emphasized) and one panel style for highlights
const PLAIN = `mt-6 ${BODY} text-espresso/80`;
const EMPHASIS = `mt-6 ${BODY} font-medium text-espresso`;
const PANEL = "my-14 rounded-3xl bg-espresso px-8 py-10 md:px-12 md:py-12";
const PANEL_TEXT = `${H3} text-cream`;
const PANEL_LABEL = `${EYEBROW} text-mustard`;

/** Renders a thought's body with a calm, uniform rhythm. */
export function ThoughtBody({
  blocks
}: ThoughtBodyProps) {
  return <>
      {blocks.map((block, i) => <Block key={i} block={block} data-id="element-354" data-mp="1e6v5n7had3vk" data-mpi={i} />)}
    </>;
}
function Block({
  block
}: {
  block: ThoughtBlock;
}) {
  switch (block.type) {
    case "h2":
      return <h2 className={`mt-20 ${H2} text-espresso`} data-id="element-355" data-mp="1n8kzsl2jygx1">{block.text}</h2>;
    case "statement":
    case "pull":
      return <p className={EMPHASIS} data-id="element-356" data-mp="cqasvq7wtai1">{block.text}</p>;
    case "stack":
      return <div className="mt-6 space-y-2" data-id="element-357" data-mp="7qofngs2zu98">
          {block.items.map(item => <p key={item.text} className={`${BODY} text-espresso`} data-id="element-358" data-mp="7t16kjftheyf">
              {item.lead && <span className="text-espresso/70" data-id="element-359" data-mp="2rtwueu465p4">{item.lead} </span>}
              <span className="font-medium" data-id="element-360" data-mp="3tyy1x46p7huw">{item.text}</span>
            </p>)}
        </div>;
    case "callout":
      return <aside className={PANEL} data-id="element-361" data-mp="vi3m9lqw4xqa">
          <p className={PANEL_TEXT} data-id="element-362" data-mp="qgmow07m7teg">{block.text}</p>
        </aside>;
    case "contrast":
      return <aside className={PANEL} data-id="element-363" data-mp="lpecqwewhtxl">
          <p className={PANEL_LABEL} data-id="element-364" data-mp="lomok6nmuyhc">{block.from.label}</p>
          <p className={`mt-2 ${H3} text-cream/60`} data-id="element-365" data-mp="gs4nbgrihi9r">{block.from.text}</p>
          <p className={`mt-8 ${PANEL_LABEL}`} data-id="element-366" data-mp="1e6gy87sq6zty">{block.to.label}</p>
          <p className={`mt-2 ${PANEL_TEXT}`} data-id="element-367" data-mp="1e8tp5aggokj5">{block.to.text}</p>
        </aside>;
    case "questions":
      return <aside className={PANEL} data-id="element-368" data-mp="33nw3frm8ui3e">
          <h3 className={PANEL_LABEL} data-id="element-369" data-mp="33oxdptvfr0k2">{block.title}</h3>
          <ol className="mt-6 grid grid-cols-1 gap-x-10 gap-y-3 md:grid-cols-2" data-id="element-370" data-mp="38mz6j6inye8q">
            {block.items.map(q => <li key={q} className={`${BODY} text-cream`} data-id="element-371" data-mp="2tykvw9f09lhm">
                {q}
              </li>)}
          </ol>
        </aside>;
    default:
      return <p className={PLAIN} data-id="element-372" data-mp="2yut5z8eciohx">{block.text}</p>;
  }
}